import React from "react";
import Section1 from "./Section1";
import { Helmet } from "react-helmet";
import Section2 from "./2ndSection";
import blogsJson from "../../data/blogs.json";
import { useParams } from "react-router-dom";

const BlogDetails = () => {
  const { handle } = useParams();
  const blog = blogsJson.find((b) => b.handle === handle);
  return (
    <div className="bg-gray-100 pt-[160px] sm:pt-0">
      <Helmet>
        <title>{blog.meta_title}</title>
        <meta
        name="description"
        content={blog.meta_desc}
        />
      </Helmet>
      {/* <Section1 /> */}
      <Section2 />
    </div>
  );
};

export default BlogDetails;
